import { cn } from '../../../utils/cn'
import { BOOKINGS_GRID, bookingColumns } from './bookingsTableLayout'

export const BookingsTableHeader = () => (
  <div
    className="grid h-[19px] items-center justify-between"
    style={{ gridTemplateColumns: BOOKINGS_GRID }}
  >
    {bookingColumns.map((column) => (
      <span
        key={column.id}
        className={cn(
          'whitespace-nowrap font-host text-[14px] font-medium leading-normal text-dash-col-head',
          column.align === 'center' && 'text-center',
        )}
      >
        {column.label}
        {column.srSuffix && <span className="sr-only"> ({column.srSuffix})</span>}
      </span>
    ))}
  </div>
)
